import { NavBar } from "./NavBar";

export { NavBar };

export default { NavBar };
